import ScalarIconBroadcast_vue_vue_type_script_setup_true_lang_default from "./ScalarIconBroadcast.vue.script.js";
//#region src/components/ScalarIconBroadcast.vue
var ScalarIconBroadcast_default = ScalarIconBroadcast_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconBroadcast_default as default };

//# sourceMappingURL=ScalarIconBroadcast.js.map